module.exports = __webpack_public_path__ + "img/fancy-list-1-2x.4549c4a.png";